import {Record, List} from 'immutable';
import Scorecard from './Scorecard';

export default class CardsProfile extends Record({
  id: null,
  name: null,
  scorecards: List(),
}) {
  constructor(object = {}) {
    super(
      Object.assign({}, object, {
        scorecards: List((object.scorecards || []).map(card => new Scorecard(card))),
      })
    );
  }
}
